export const getBillingDefaultValues = (user: User, billingInfo?: BillingInfo) => {
  const card = billingInfo?.cards?.[0];
  const billing = card?.billing_details;
  const address = billing?.address;

  return {
    firstName: user.billingName?.split(' ')[0] || user.firstName || '',
    lastName: user.billingName?.split(' ').slice(1).join(' ') || user.lastName || '',
    country: address?.country || user.country || '',
    city: address?.city || user.city || '',
    address: address?.line1 || user.address || '',
    state: address?.state || user.state || '',
    zipCode: address?.postal_code || user.zip || '',
  };
};

export const getBillingDay = (billingInfo?: BillingInfo): number => {
  const anchor = billingInfo?.customer?.subscriptions?.[0]?.billingCycleAnchor;
  return anchor ? new Date(anchor * 1000).getDate() : 21;
};

const MIN_AVATAR_WIDTH = 800;
const MIN_AVATAR_HEIGHT = 800;
const ALLOWED_AVATAR_TYPES = ['image/jpeg', 'image/png'];

export const validateAvatarFile = (file: File): Promise<string | null> => {
  if (!ALLOWED_AVATAR_TYPES.includes(file.type)) {
    return Promise.resolve('Only JPEG and PNG images are allowed.');
  }

  return new Promise((resolve) => {
    const image = new Image();
    const objectUrl = URL.createObjectURL(file);

    image.onload = () => {
      URL.revokeObjectURL(objectUrl);

      if (image.width < MIN_AVATAR_WIDTH || image.height < MIN_AVATAR_HEIGHT) {
        resolve(`Image must be at least ${MIN_AVATAR_WIDTH} x ${MIN_AVATAR_HEIGHT}px.`);
        return;
      }

      resolve(null);
    };

    image.onerror = () => {
      URL.revokeObjectURL(objectUrl);
      resolve('Invalid image file.');
    };

    image.src = objectUrl;
  });
};
